// source: type/delivery_limit_time.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.DeliveryLimitTime', null, global);
goog.exportSymbol('proto.type.DeliveryLimitTimeType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.DeliveryLimitTime = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.DeliveryLimitTime, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.DeliveryLimitTime.displayName = 'proto.type.DeliveryLimitTime';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.DeliveryLimitTime.prototype.toObject = function(opt_includeInstance) {
  return proto.type.DeliveryLimitTime.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.DeliveryLimitTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.DeliveryLimitTime.toObject = function(includeInstance, msg) {
  var f, obj = {
    fromInSeconds: jspb.Message.getFieldWithDefault(msg, 1, 0),
    toInSeconds: jspb.Message.getFieldWithDefault(msg, 2, 0),
    deliveryLimitTimeType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of DeliveryLimitTime as accepted by the `fromObject` method.
 * @record
 */
proto.type.DeliveryLimitTime.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.fromInSeconds;

  /** @type {?|undefined} */
  this.toInSeconds;

  /** @type {?|undefined} */
  this.deliveryLimitTimeType;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.DeliveryLimitTime.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.DeliveryLimitTime}
 */
proto.type.DeliveryLimitTime.fromObject = function(obj) {
  var msg = new proto.type.DeliveryLimitTime();
  obj.fromInSeconds != null && jspb.Message.setField(msg, 1, obj.fromInSeconds);
  obj.toInSeconds != null && jspb.Message.setField(msg, 2, obj.toInSeconds);
  obj.deliveryLimitTimeType != null && jspb.Message.setField(msg, 3, obj.deliveryLimitTimeType);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.DeliveryLimitTime}
 */
proto.type.DeliveryLimitTime.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.DeliveryLimitTime;
  return proto.type.DeliveryLimitTime.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.DeliveryLimitTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.DeliveryLimitTime}
 */
proto.type.DeliveryLimitTime.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFromInSeconds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setToInSeconds(value);
      break;
    case 3:
      var value = /** @type {!proto.type.DeliveryLimitTimeType} */ (reader.readEnum());
      msg.setDeliveryLimitTimeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.DeliveryLimitTime.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.DeliveryLimitTime.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.DeliveryLimitTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.DeliveryLimitTime.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFromInSeconds();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getToInSeconds();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDeliveryLimitTimeType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int64 from_in_seconds = 1;
 * @return {number}
 */
proto.type.DeliveryLimitTime.prototype.getFromInSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.DeliveryLimitTime} returns this
 */
proto.type.DeliveryLimitTime.prototype.setFromInSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 to_in_seconds = 2;
 * @return {number}
 */
proto.type.DeliveryLimitTime.prototype.getToInSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.DeliveryLimitTime} returns this
 */
proto.type.DeliveryLimitTime.prototype.setToInSeconds = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional DeliveryLimitTimeType delivery_limit_time_type = 3;
 * @return {!proto.type.DeliveryLimitTimeType}
 */
proto.type.DeliveryLimitTime.prototype.getDeliveryLimitTimeType = function() {
  return /** @type {!proto.type.DeliveryLimitTimeType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.type.DeliveryLimitTimeType} value
 * @return {!proto.type.DeliveryLimitTime} returns this
 */
proto.type.DeliveryLimitTime.prototype.setDeliveryLimitTimeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.type.DeliveryLimitTimeType = {
  DEADLINE: 0,
  DELIVERY_TIME: 1
};

goog.object.extend(exports, proto.type);
